import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from '@services/auth';

export const adminAuthGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    return router.createUrlTree(['/admin-login'], {
      queryParams: { returnUrl: state.url },
    });
  }

  const user = authService.getCurrentUser();

  if (user?.type === 'admin' || user?.type === 'staff') {
    return true;
  }

  if (user?.type === 'customer') {
    return router.createUrlTree(['/home']);
  }

  return authService.ensureDashboardSession().pipe(
    map((allowed) => {
      if (allowed) {
        return true;
      }

      if (authService.getCurrentUser()?.type === 'customer') {
        return router.createUrlTree(['/home']);
      }

      authService.clearSession();
      return router.createUrlTree(['/admin-login'], {
        queryParams: { returnUrl: state.url },
      });
    }),
  );
};
